import React from "react"
import ShowCase from "../components/Showcase"
import { View, Text, CurrencyInput } from "react-ame-components"

export class CurrencyInputExample extends React.Component {
  state = {
    value: 700,
  }
  render() {
    return (
      <ShowCase
        centerGrid
        title="Componente ValueInput"
        description="Componente para entrada de valor, podendo ser moeda ou outro valor">
        <CurrencyInput
          value={this.state.value}
          prefix="R$"
          maxLength={6}
          valueType="currency"
          onChange={v => this.setState({ value: v })}
          color="primary"
        />
        <View>
          <Text>O valor digitado foi de: {this.state.value}</Text>
        </View>
      </ShowCase>
    )
  }
}
